export const viewAdminDashboard_actionType = {
    GET_VIEW_DASHBOARD_SUCCESS : 'GET_VIEW_DASHBOARD_SUCCESS',
    GET_VIEW_DASHBOARD_FAILURE : 'GET_VIEW_DASHBOARD_FAILURE',
    RESET_VIEW_DASHBOARD_SUCCESS : 'RESET_VIEW_DASHBOARD_SUCCESS'
};